const ICON_RULES = [
  { test: /re-?open/i, icon: "mdi-lock-open-outline" },
  { test: /discard/i, icon: "mdi-delete-outline", destructive: true },
  { test: /deactivate|inactive/i, icon: "mdi-close-octagon-outline", destructive: true },
  { test: /^close/i, icon: "mdi-close-circle-outline", destructive: true },
  { test: /delete/i, icon: "mdi-delete-outline", destructive: true },
  { test: /change status|status/i, icon: "mdi-swap-horizontal" },
  { test: /reassign/i, icon: "mdi-account-switch-outline" },
  { test: /download.*pdf|pdf/i, icon: "mdi-file-pdf-box" },
  { test: /download/i, icon: "mdi-cloud-download-outline" },
  { test: /visit.*date|date.*time/i, icon: "mdi-calendar-clock-outline" },
  { test: /remark/i, icon: "mdi-message-text-outline" },
  { test: /edit ticket/i, icon: "mdi-ticket-outline" },
  { test: /edit foc|\bfoc\b/i, icon: "mdi-gift-outline" },
  { test: /edit payout|payout/i, icon: "mdi-cash-multiple" },
  { test: /payment/i, icon: "mdi-cash-plus" },
  { test: /service charge/i, icon: "mdi-pencil-outline" },
  { test: /repeat/i, icon: "mdi-sync" },
  { test: /^approve$/i, icon: "mdi-check" },
  { test: /^reject$/i, icon: "mdi-close", destructive: true },
  { test: /accept|reject/i, icon: "mdi-check-decagram-outline" },
  { test: /component/i, icon: "mdi-information-outline" },
  { test: /edit/i, icon: "mdi-pencil-outline" },
  { test: /view/i, icon: "mdi-eye-outline" },
];

/**
 * Resolve icon and destructive styling from a menu item label.
 * @param {string} label
 * @returns {{ icon: string, destructive: boolean }}
 */
export function resolveActionMenuIcon(label) {
  const text = String(label || "").trim();

  for (const rule of ICON_RULES) {
    if (rule.test.test(text)) {
      return { icon: rule.icon, destructive: !!rule.destructive };
    }
  }

  return { icon: "mdi-dots-horizontal-circle-outline", destructive: false };
}
